<template>
  <div class="v-searchable-tree">
    <button class="small secondary icon rounded retry-button" @click="connect" v-if="isConnectionInErrorState">
      <v-icon name="refresh-cw" />
      {{ $t('Retry connecting') }}
    </button>

    <template v-if="canConnect && hasTree">
      <div class="search">
        <fieldset>
          <v-input
            icon="search"
            :placeholder="$t('Search')"
            class="small"
            icon-position="right"
            v-model="searchQuery"
            :delay="500"
          />
        </fieldset>
      </div>

      <v-tree
        :nodes="nodes"
        :is-searching="hasSearchQuery"
        :emit-on-click="true"
        @node-selected="emit('node-selected', $event)"
        v-if="hasTree"
      />
    </template>
    <template v-else>
      <div class="no-connection">
        <v-icon name="wifi-off"></v-icon>
        <h4>{{ $t('Connection Failed') }}</h4>
        <h6>{{ $t('Check your connection details') }}</h6>

        <button class="primary" @click="modal.show('connection')">{{ $t('Connection Details') }}</button>
        <small v-if="isConnecting">
          <span class="badge primary">
            <v-loader />
            {{ $t('attempting to reconnect') }}
          </span>
        </small>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { $t } from '/@/i18n'
import { NodeType } from '/@/shared/actions/SearchMotorcortexTree'
import { computed, ref } from 'vue'
import { useMotorcortex } from '/@/shared/composables/motorcortex'
import { useModal } from '@vectioneer/ui'

export type Node = {
  node?: NodeType
  info: any
  channel?: any
}

const emit = defineEmits<{
  (e: 'node-selected', node: Node): void
}>()

const modal = useModal()
const { connect, canConnect, hasTree, tree, search, isConnectionInErrorState, isConnecting } = useMotorcortex()

const searchQuery = ref<string>('')

const hasSearchQuery = computed(() => searchQuery.value.length > 0)
const nodes = computed(() => (hasSearchQuery.value ? search(searchQuery.value) : tree.value?.children.at(0)))
</script>
<style src="./style.css"></style>
